import { render, staticRenderFns } from "./LeadDealForm.vue?vue&type=template&id=70e71a16&scoped=true&"
import script from "./LeadDealForm.vue?vue&type=script&lang=js&"
export * from "./LeadDealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e71a16",
  null
  
)

export default component.exports